import type { ChatTransport } from "./types";
import { convertSession } from "@/components/analysis/chat/v2/utils/converters";
import { streamChatMessage } from "@/components/analysis/chat/v2/utils/streamChatMessage";
import { getJson } from "@/utils/routeUtils";

export const workspaceChatTransport: ChatTransport = {
  fetchChat: async ({ chatId, orgId }) => {
    const result = await getJson("/api/analysis/chat/v2/load", {
      chatId,
      orgId,
    });
    if (result.success) {
      return { type: "found", chat: convertSession(result.data) };
    }
    return result.statusCode === 404
      ? { type: "not-found" }
      : {
          type: "failed",
          error: new Error(
            `Unified chat failed to load with status ${result.statusCode}`
          ),
        };
  },
  sendMessage: ({ orgId, surveyIds, pageContext, ...args }) =>
    streamChatMessage({
      ...args,
      type: "analysis-chat-v2",
      owner: { type: "org", orgId, surveyIds },
      pageContext,
    }),
};
